module.exports = __webpack_public_path__ + "img/311.9dc1a22a.png";